// extracted by mini-css-extract-plugin
export default {"headline":"styles_headline__Jk5XJ"};